import "./App.css";

import { BrowserRouter } from "react-router-dom";

import PrivateRoute from "./PrivateRoute";
function App() {


  return (
    <div className="App">
      <BrowserRouter>
        <PrivateRoute />
      </BrowserRouter>
    </div>
  );
}

export default App;


